// extracted by mini-css-extract-plugin
export default {"info":"Info_info__mgofX","fullWidth":"Info_fullWidth__ZB+4y"};